import React from 'react';
import { Helmet } from 'react-helmet';
import { Link } from 'react-router-dom';

const BASE_URL = process.env.REACT_APP_BASE_URL || 'https://www.echt.gold';

const Schmuckankauf = () => {
  return (
    <>
      <Helmet>
        <title>Schmuckankauf - Echt Gold | Gold- & Silberschmuck</title>
        <meta name="description" content="Schmuckankauf - Ringe, Ketten, Armbänder aus Gold und Silber. Auch Bruchschmuck. Faire Bewertung, sofortige Auszahlung in NRW." />
        <link rel="canonical" href={`${BASE_URL}/schmuckankauf`} />
      </Helmet>

      <script type="application/ld+json">
        {JSON.stringify({
          "@context": "https://schema.org",
          "@type": "BreadcrumbList",
          "itemListElement": [
            {"@type": "ListItem", "position": 1, "name": "Home", "item": `${BASE_URL}/`},
            {"@type": "ListItem", "position": 2, "name": "Schmuckankauf", "item": `${BASE_URL}/schmuckankauf`}
          ]
        })}
      </script>

      <div className="bg-black/90 py-8 border-b border-gold/20">
        <div className="container mx-auto px-4">
          <div className="text-sm text-gray-400 mb-2">
            <Link to="/" className="hover:text-gold">Home</Link> / <span className="text-gold">Schmuckankauf</span>
          </div>
          <h1 className="text-4xl md:text-5xl font-bold gold-text">Schmuckankauf</h1>
        </div>
      </div>

      <section className="section section-dark">
        <div className="container">
          <div className="max-w-4xl mx-auto">
            <h2 className="text-3xl font-bold mb-6 gold-text text-center">Gold- und Silberschmuck sicher verkaufen</h2>
            <p className="text-gray-300 mb-8 text-lg text-center">
              Wir kaufen Ihren Schmuck aus Gold, Silber, Platin - neu, alt, beschädigt oder defekt. Faire Preise nach Edelmetallgehalt.
            </p>
            
            <div className="grid md:grid-cols-2 gap-6 mb-12">
              <div className="card">
                <h3 className="text-xl font-bold mb-3 gold-text">Goldschmuck</h3>
                <ul className="text-gray-300 space-y-2">
                  <li>• Goldketten & Colliers</li>
                  <li>• Ringe & Eheringe</li>
                  <li>• Armbänder & Armreifen</li>
                  <li>• Ohrringe & Ohrstäbe</li>
                  <li>• Broschen & Anhänger</li>
                  <li>• Bruchgold & defekte Stücke</li>
                </ul>
              </div>
              <div className="card">
                <h3 className="text-xl font-bold mb-3 gold-text">Silberschmuck</h3>
                <ul className="text-gray-300 space-y-2">
                  <li>• Sterling Silber (925)</li>
                  <li>• Silberketten</li>
                  <li>• Silberringe</li>
                  <li>• Armbänder</li>
                  <li>• Anhänger & Charms</li>
                  <li>• Vintage Silberschmuck</li>
                </ul>
              </div>
            </div>

            <div className="card bg-gold/10 border-gold/30">
              <h3 className="text-xl font-bold mb-3 gold-text">Auch defekter Schmuck wird angekauft</h3>
              <p className="text-gray-300">
                Kaputte Ketten, einzelne Ohrringe, verb gene Ringe - wir kaufen Schmuck in jedem Zustand. Der Wert richtet sich nach dem Edelmetallgehalt, nicht nach dem optischen Zustand.
              </p>
            </div>
          </div>
        </div>
      </section>

      <section className="section section-darker">
        <div className="container">
          <div className="card text-center max-w-3xl mx-auto">
            <h2 className="text-3xl font-bold mb-4 gold-text">Schmuck jetzt verkaufen</h2>
            <p className="text-gray-300 mb-8">
              Lassen Sie Ihren Schmuck kostenlos bewerten
            </p>
            <div className="flex flex-wrap gap-4 justify-center">
              <Link to="/kontakt" className="btn-primary">Kostenlose Bewertung</Link>
              <Link to="/versandankauf" className="btn-secondary">Per Versand einsenden</Link>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Schmuckankauf;